export default Object.freeze({
  Attempt: 1,
  Percent: 2,
});
